/* eslint-disable */
import axios from 'axios';
import L from 'leaflet';
import moment from 'moment';
import * as images from '../img/index';
import $ from 'jquery';
import jqueryRotate from './jquery-rotate';

const airportDepartureIcon = require('../../../../static/images/airport-departure-icon.png');
const airportArrivalIcon = require('../../../../static/images/airport-arrival-icon.png');

jqueryRotate($);

// -----------------------------------------------
// add great circle arc to Polyline
L.Polyline.include({    // draw a polyline using geodesics
    greatArc: function(npoints) {
        var points = [];
        var start = this._latlngs[0],
                end = this._latlngs[1];
        var startlng = (start.lng + 180) % 360 + ((start.lng < -180 || start.lng === 180) ? 180 : -180);
        var endlng = (end.lng + 180) % 360 + ((end.lng < -180 || end.lng === 180) ? 180 : -180);
        if (npoints === undefined) { npoints = 1 + Math.ceil(Math.abs(startlng - endlng)); }
        if (npoints <= 2) {
            points.push([start.lat, startlng]);
            points.push([end.lat, endlng]);
        } else {
            var D2R = L.LatLng.DEG_TO_RAD;
            var R2D = L.LatLng.RAD_TO_DEG;
            var startx = D2R * startlng,
                    starty = D2R * start.lat,
                    endx = D2R * endlng,
                    endy = D2R * end.lat;
            var g = 2.0 * Math.asin(Math.sqrt(Math.pow(Math.sin((starty - endy) * 0.5), 2) +
            Math.cos(starty) * Math.cos(endy) * Math.pow(Math.sin((startx - endx) * 0.5), 2)));
            var isg = 1 / Math.sin(g);
            var delta = 1.0 / (npoints - 1);
            var wrap = Math.abs(startlng - endlng) > 180; // does route cross anti-meridian?
            for (var i = 0; i < npoints; i++) {
      var step = delta * i;
                var A = Math.sin((1 - step) * g) * isg;
                var B = Math.sin(step * g) * isg;
                var x = A * Math.cos(starty) * Math.cos(startx) + B * Math.cos(endy) * Math.cos(endx);
                var y = A * Math.cos(starty) * Math.sin(startx) + B * Math.cos(endy) * Math.sin(endx);
                // var z = A * Math.sin(starty) + B * Math.sin(endy);
                points.push(createLatLng(R2D *
                        Math.atan2(A * Math.sin(starty) + B * Math.sin(endy), Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2))),
                        R2D * Math.atan2(y, x), wrap));
    }
        }
        this._latlngs = points;
        return this;
    }
});

export default function addFlight(
  flightID,
  map,
  store,
  loadFlightFlick,
  loadByCarrierFlightNumberAndDate,
  params,
  disableRefresh,
  done) {
  var updateRate = 60000; // millis
  var aniRate = 250;  // 1/4 second
  var rotRate = aniRate / 500;    // 2 degrees per second max
  var fullscreentimerInterval = 3000; // 3 seconds
  var guid = '34b64945a69b9cac:5ae30721:13ca699d305:XXXX';

  // var loRes = window.flickLoRes ? true : false;
  var loRes = true;
  var isLteIE8 = window.isLteIE8 ? true : false;

  var the_url = window.location;  // url that initiated the app
  // var map;    // Leaflet map object
  var dport,  // departure airport data
          dpos,   // lat/lng position of departure airport
          dmarker,    // departing airport marker
          aport,  // arrival airport data
          apos,   // lat/lng position of arrival airport
          amarker,    // arriving airport marker
          dvport,   // diverted airport data
          dvpos,    // lat/lng position of diverted airport
          dvmarker, // diverted airport marker
          airplane,   // L.marker for airplane icon
          fpos,   // lat/lng position of airplane
          multi,  // lat/lngs for flight path
          layers = {
              pathHalo: null, path: null, // actual path
              planHalo: null, plan: null, // flight plan (if available)
              arcHalo: null, arc: null,   // shortest arc (geodesic)
              mini: null },   // mini-tracker
          wrap;   // does route cross the anti-meridian?
  var maxZoom = 11;   // cannot zoom in any more than this
  var logo = true, logoimg, logourl;  // airline logo image and prefetch (for flight label)
  var flightData, // flight data returned by API
          actualposs = [],    // actual positions (built up)
          apts,   // last actual pos timestamp
          pos,    // current position data returned by API
          timestamp,  // time of API call
          nodata = false; // haven't received data from API recently
  var curpos, // current lat/lng of animation
          currot, // current heading of animation
          curspeed, // current speed of airplane in mph
          curheading, // current heading
          curstatus = null,   // current status
          estland = true, // can estimate landing
          estdep = true,  // can estimate departure
          taxi = false,   // flight is active, but no positions yet
          frames = 0, // frames of animation remaining
          rotframes,  // frames of rotation animation remaining
          loadtimer,  // first data load timer
          anitimer,   // animation timer
          maintimer;  // mainloop timer
  var vlat, vlng, vrot;   // animation parameters
  var zooming = false,    // true during zoom animation
          panning = false;    // true during panning animation
  var numpos, // debug stuff for simulating a data loss
          data_off = 0,   // index of where data is off for testing
          data_on = 0;    // index of where data is back on
  var trackcontrol, layercontrol, infocontrol;  // UI
  var fullscreentimer, hidecontrols, unhidecontrols, drawerwasopen = false;   // hide buttons and drawer timer
  var controlshidden = false;
  var flightBounds; // area of world to display

  // process URL parameters
  var airline = params.carrier,    // airline code
          flightnum = params.flightNumber,  // flight number
          hours24 = false, // 12 or 24 hour time
          metric = false, // metric or US
          mapType = 'sat', // name of map (sat or map)
          showLabels = false, // show label layer on sat map
          showTerrain = false,    // show terrain layer on map
          showPath = true,    // actual path
          showPlan = true,    // flight plan
          showArc = false,    // great arc
          showMini = true,    // mini-tracker
          showWeather = false,    // US weather
          demo = false,   // demo mode for signage
          view = '2D',    // 3D mode not really working
          zoomControl = 'auto',   // show zoom control (auto = if !touch)
          autoHide = 'auto',  // auto hide controls (auto = if touch)
          edgeurl = 'http://edge.flightstats.com/flight/tracker/',    // production
          miniurl = 'http://edge.flightstats.com/flight/mini-tracker/',   // production
          trackingDist = 0.4, // % plane can get away from center of screen in tracking mode
          infoType = 'drawer', //drawer or popup
          debug = false,  // debug to console
          fslogo = false; // mobile web

  var planeIcon = images.plane;

  const currentDay = moment().format('MMM DD');
  if (currentDay === 'May 04') {
    planeIcon = images.xwing;
  }

  var flightLayers = L.LayerGroup();
  // -----------------------------------------------
  // airplane flight marker
  var FlightMarker = L.Marker.extend({
      defaultFlightMarkerOptions: {
          icon: L.divIcon({ // airplane icon (rotatable)
                  html: (loRes ?
                    '<img class="airplaneicon" src="' + planeIcon + '" />' :
                    '<img class="airplaneshadow" src="' + images.shadow_4_2x + '" /><img class="airplaneicon" src="' + images.plane_2x + '" />'),
                  iconSize: [48,48],
                  iconAnchor: [24, 24],
                  className: ''
          }),
          zIndexOffset: 1000
      },
      initialize: function(latlng) {
          L.Util.setOptions(this, this.defaultFlightMarkerOptions);
          this._latlng = L.latLng(latlng);
          this._stamp = 0;
          if (infoType === 'popup') { this.bindPopup('', {offset: L.point(0, -12), minWidth: 250, autoPan: false}); }
      },
      rotate: function(deg) { // add rotate function to Marker class
          $(this._icon).find('img').rotate(deg); // css('transform', 'rotate('+deg+'deg)');
          return this;
      },
      stamp: function(ds) {
          if (ds) {
              if (typeof ds === 'string') { ds = Date.parse(ds); }
              this._stamp = ds;
              return this;
          }
          return this._stamp;
      },
      setShadow: function(alt) {  // shadow for flight icon
          if (loRes){
              return this;
          }

          var $shadow = $(this._icon).find('.airplaneshadow');
          var offset = isNaN(alt) ? 0 : Math.round(alt * 0.00035); // shadow offset based on altitude
          var shimg = images['shadow_'+ (Math.max(0, Math.min(9, Math.floor(alt / 3000))))+'_2x']; // shadow image 0-9 (progressive blur)
          if ($shadow.attr('src') !== shimg) { $shadow.attr('src', shimg); }
          $shadow.css({opacity: 0.7, left: offset-19, top: offset-14});
          return this;
      }
  });

  var flightMarker = function(latlng) {
    return new FlightMarker(latlng);
  };

  // ---------------------------------------------------------
  // TrackControl is used to track the flight and zoom the map
  var TrackControl = L.Class.extend({

      onAdd: function(map) {

          this._map = map;
          this._tracking = 0;

          var link = this._link = L.DomUtil.get('control-track');
          L.DomEvent
                  .on(link, 'click', L.DomEvent.stop)
                  .on(link, 'mousedown', L.DomEvent.stop)
                  .on(link, 'dblclick', L.DomEvent.stop)
                  .on(link, 'click', L.DomEvent.preventDefault)
                  .on(link, 'click', this.settrack, this);
      },

      onRemove: function (/* map */) {
      },

      reset: function() {
          if (this._tracking === 2) {
              this._tracking = 1;
              this._link.style.backgroundColor = '';
              this._link.style.backgroundImage =  loRes ? 'url(' + images['tracking_icon'] + ')' : 'url(' + images['tracking_icon_2x'] + ')';
          }
      },

      isTracking: function() {
          return this._tracking === 2;
      },

      settrack: function(/* e */) {
          if (!demo) { unhidecontrols(); }
          if (this._tracking === 2) {
              this._tracking = 0;
              this._link.style.backgroundColor = '';
              this._link.style.backgroundImage = loRes ? 'url(' + images['tracking_icon'] + ')' : 'url(' + images['tracking_icon_2x'] + ')';
              setfullview(this._map);
          } else {
              this._tracking = 2;
              this._link.style.backgroundColor = loRes ? 'rgb(48, 106, 219)' : 'rgba(48, 106, 219, 0.75)'; // '#306ADB';  // blue
              this._link.style.backgroundImage = loRes ? 'url(' + images['tracking_icon_white'] + ')' : 'url(' + images['tracking_icon_white_2x'] + ')';
              settrackingview(this._map);
              setFlightPath();
          }
      }

  });

  trackcontrol = new TrackControl();

  function loop() {
    var ajaxoptions = { guid: guid , airline: airline, flight: flightnum, flightPlan: layers.plan===null };
    if (apts !== undefined) {
        ajaxoptions.limit = apts;
    }

    let queryArr = [];
    let querystring = '?';

    for (let item in ajaxoptions) {
      queryArr.push(item + '=' + ajaxoptions[item]);
    }

    querystring = querystring + queryArr.join('&');

    store.dispatch(loadFlightFlick(flightID, querystring))
    .then((res) => {
      if (res.error) {
        return;
      }

      if (res) {
        getFlight(res.result);
      }

      return store.dispatch(loadByCarrierFlightNumberAndDate(params))
    })
    .catch((e) => {
      console.log('[FLICK]: Error fetching flight:', e);
    });
  }

  loop();

  if (maintimer) {
    clearInterval(maintimer);
  }

  if (!disableRefresh) {
    maintimer = setInterval(loop, updateRate);
  }

  function getFlight(data /*, status, xhr */) { // callback

      if (data.status || data.tracks) {   // error!
          map.fitWorld();
          clearInterval(loadtimer);
          return; // give up
      }

      flightData = data;
      dport = data.airports.departure;    // departure airport data
      aport = data.airports.arrival;  // arrival airport data
      if (data.statusCode === 'D') {
        dvport = data.airports.diverted;  // diverted airport data
      }

      var newp = (!isFlightUnknown(data.statusCode)) ? data.positions : [];
      if (newp.length > 0) {
          if (debug && apts !== undefined) {
              console.log('time diff: ', Date.parse(newp[newp.length - 1].date) - Date.parse(apts));
          }
          actualposs = newp.concat(actualposs);
          apts = newp[0].date;
      }
      numpos = actualposs.length;

      if (data_off !== 0) {   // simulate data loss for testing
          if (data_on === 0) {    // data is dead
              actualposs.splice(0, numpos-data_off);
          } else {    // data is back on
              actualposs.splice(-data_on, data_on-data_off);
          }
      }

      if (data.statusCode !== curstatus) {    // change of status
          curstatus = data.statusCode;
          if (numpos === 0 && curstatus === 'A') {    // taxi to runway
              showNote('Flight has departed the gate; tracking should begin after take off',
                      new Date(data.responseTime*1000).toUTCString());
              taxi = true;
          } else {
              // var m = flightStatusMessages[curstatus];
              // if (m) { showNote(m); }
          }
      }

      var newheading = +(data.heading || data.bearing);

      if (numpos > 0 && curstatus !== 'L' && !isFlightUnknown(curstatus)) {  // have positions

          var newpos = actualposs[0];
          var newdate = Date.parse(newpos.date);
          if (newdate < 1000) { alert('bad date!',newpos.date); }
          var diff = data.responseTime - newdate/1000 + (newpos.source === 'ASDI'? -300 : 0);

          // !!! Want to use timestamp from API instead of from position data, but it might not be reliable enough
          if (timestamp === undefined) { timestamp = newdate; }   // if uninitialized
          timestamp += updateRate;    // 30 seconds
          if (curstatus === 'A') {    // in flight
              if (taxi && numpos > 0) {
                  showNote('The flight is now tracking');
                  taxi = false;
              }
                                                  // no data for two minutes OR last data point is more than 10 minutes old
              if (!nodata && (timestamp - newdate > 120000 || diff > 600)) {
                  showNote('The flight is temporarily beyond the range of our tracking network');
                  nodata = true;
                  // if (layers.path) { setFlightPath(true); }    // draw entire flight history
                  // drawercontrol.update();
              }
              if (estland && nodata && data.responseTime > data.operationalTimes.arrivalTime + 120) {
                  showNote('The flight is estimated to have landed, but is beyond the range of our tracking network');
                  estland = false;    // suppress future Notes
              }
          }

          if (pos && newpos.lat === pos.lat && newpos.lon === pos.lon &&
                  newpos.date === pos.date && pos.altitudeFt === newpos.altitudeFt) {
              return; // data has not changed
          }

          if (debug) {
              // console.log('Edge API data: ', data, newpos.source, diff);
              if (curstatus !== 'A') { console.log('status: ', curstatus, flightData.statusCode, flightData.flightStatus, flightData.statusName); }
          }

          pos = newpos;
          timestamp = newdate;

          if (nodata && diff < 600) {
              nodata = false;
              estland = true; // may calculate a landing again
              showNote('Re-established position data');
              if (wrap !== undefined) {   // jump to new position
                  phat(createLatLng(+pos.lat, +pos.lon, wrap), newheading, +pos.altitudeFt, timestamp);
              }
          }

      } else {    // no positions
          var ap = curstatus === 'L' ? data.airports.arrival :
            (curstatus === 'D' && data.airports.diverted) ? data.airports.diverted : data.airports.departure;
          timestamp = data.responseTime;
          pos = {
              lat: ap.latitude,
              lon: ap.longitude,
              date: timestamp,
              altitudeFt: ap.elevationFt,
              speedMph: 0
          };
          if (curstatus === 'S' && estdep && data.responseTime > data.operationalTimes.departureTime + 120) {
              showNote('The flight is past its expected take-off time, but is not reporting tracking data yet');
              estdep = false; // suppress future Notes
          }
      } // end have positions or not

      if (wrap === undefined) { // first time called

          clearInterval(loadtimer);

          if (airline === undefined) {    // not supplied by URL parameter
              airline = flightData.carrierFs;
          }
          if (flightnum === undefined) {
              flightnum = flightData.carrierFlightId;
          }

          wrap = Math.abs(dport.longitude - aport.longitude) > 180; // does route cross anti-meridian?

          dpos = createLatLng(+dport.latitude, +dport.longitude, wrap);
          apos = createLatLng(+aport.latitude, +aport.longitude, wrap);
          if (dvport && dvport.latitude !== '' && dvport.latitude !== '') {
            dvpos = createLatLng(+dvport.latitude, +dvport.longitude, wrap);
          }
          fpos = createLatLng(+pos.lat, +pos.lon, wrap);
          // currot = +(data.heading || data.bearing);

          // airline logo prefetch
          logourl = 'http://d3o54sf0907rz4.cloudfront.net/airline-logos/v2/centered/logos/png/300x100/'+
                  airline.toLowerCase().replace('*', '@')+'-logo.png';
          // '<object class="labelimg" data="http://dskx8vepkd3ev.cloudfront.net/airline-logos/v2/logos/svg/'+
          // flightData.carrierFs.toLowerCase().replace('*', '@')+'-logo.svg" type="image/svg+xml"></object>'+

          // map.on('load', mapReady);
          mapReady();
          setfullview(map);   // fires mapReady

          if (demo) {
              setTimeout(function() {
                  trackcontrol.settrack(map); // go into tracking mode in 15 seconds
              }, 15000);
          }

      } else {    // update
          fpos = createLatLng(+pos.lat, +pos.lon, wrap);
          if (!fpos.equals(curpos)) {
              aniPhats(fpos, newheading, +pos.altitudeFt, timestamp, +pos.speedMph);
              setFlightPath();
              // infocontrol.update();
          }
      }

      function getCurrentFlightPosition(){
        return curpos;
      }
      map.getCurrentFlightPosition = getCurrentFlightPosition;

      function showNote(message) {

      }

    function isFlightUnknown(statusCode) {
      return (statusCode === 'U' || statusCode === 'I' || statusCode === 'DN' || statusCode === 'NO');
    }

      // ------------------------------------------------
      // map is ready, draw everything for the first time
      function mapReady(/* e */) {

          var tDepIcon = scaleTowers(map, 'departure');  // generate and scale tower icon
          var tArrIcon = scaleTowers(map, 'arrival');  // generate and scale tower icon

          // departing airport marker
          dmarker = L.marker(dpos, {
                  icon: tDepIcon
              }).addTo(map);
          // .on('click', function() {
          //         if (infoType === 'popup') { dmarker.openPopup(); }
          //         infocontrol.content(function() { return airportinfo(true); });
          //     });
          // if (infoType === 'popup') { dmarker.bindPopup('', {offset: L.point(2, -66), minWidth: 250}); }

          // arriving airport marker
          amarker = L.marker(apos, {
                  icon: tArrIcon
              }).addTo(map);
          // .on('click', function() {
          //          if (infoType === 'popup') { amarker.openPopup(); }
          //          infocontrol.content(function() { return airportinfo(false); });
          //     });
          // if (infoType === 'popup') { amarker.bindPopup('', {offset: L.point(2, -66), minWidth: 250}); }

          if (dvpos) {
            var tDivIcon = scaleTowers(map, 'diverted', true);  // generate and scale tower icon

            // diverted airport marker
            dvmarker = L.marker(dvpos, {
              icon: tDivIcon
            }).addTo(map);
          }
          // create flight plan polylines
          var p = flightData.flightPlan;  // do flight plan (waypoints) if available

          if (p) { // there is a flight plan
              var positions = new Array(p.length);
              for (var i = 0; i < p.length; i++) {
                  positions[i] = createLatLng(+p[i].lat, +p[i].lon, wrap);
              }
              layers.planHalo = L.polyline(positions, { color: '#D1D1D2', weight: 12, opacity: 0.4, clickable: false });
              layers.plan = L.polyline(positions, { color: '#362F2D', weight: 8 , opacity: 0.6, clickable: false });
              if (showPlan) { // show plan
                  layers.planHalo.addTo(map);
                  layers.plan.addTo(map);
              }
          } else {    // no plan
              // layercontrol.noPlan();  // disable flight plan button

              // create great arc (geodesic) polylines
              layers.arcHalo = L.polyline([dpos, apos], { color: '#828483', weight: 7, opacity: 0.4, clickable: false }).greatArc();
              layers.arc = L.polyline([dpos, apos], { color: '#D1D1D2', weight: 4, opacity: 0.6, clickable: false }).greatArc();
              layers.arcHalo.addTo(map);
              layers.arc.addTo(map);
          }

          // flight marker (airplane)
          var alt = +(pos.altitudeFt || 0);
          var heading = +(flightData.heading || flightData.bearing);
          // !!! now that I get current time from API, fix this to go back 1 minute in time to start animation
          // and display warning if no new data

          if (actualposs.length > 2 && curstatus !== 'L' && curstatus !== 'D' && !nodata) {
            p = actualposs[2];
            var a2 = +(p.altitudeFt || alt);
            if (a2 > 40000) {
              a2 = alt;
            }   // fix bad data for airplanes on ground
            var fp2 = createLatLng(+p.lat, +p.lon, wrap);
            var speed = +pos.speedMph;
            // if (fp2.distanceTo(fpos) > speed * 53.6448) {    // more than 2 minutes of distance
            if (fp2.distanceTo(fpos) > speed * 100) {   // more than 3.7 minutes of distance
              phat(fpos, heading, alt, p.date);   // set initial position
            } else {
              phat(fp2, heading, a2, p.date); // set initial position
              aniPhats(fpos, heading, +pos.altitudeFt, timestamp, +pos.speedMph); // start airplane moving
            }
          } else {
            phat(fpos, heading, alt, pos.date); // set initial position
          }
          setFlightPath(); // draw actual flight position data

          done({
            flightMarker: airplane,
            departureAirportMarker: dmarker,
            arrivalAirportMarker: amarker,
            divertedAirportMarker: dvmarker,
            edgeFlightData: flightData,
            timer: maintimer,
            layers: layers
          });
      } // end mapReady

      // set position of airplane icon
      function phat(p, h, a, t) { // position, heading, altitude, time
          if (curstatus === 'L') { p = apos; }    // land plane
          curpos = p;
          currot = h;
          if (airplane) {
              airplane.rotate(h).setShadow(a).stamp(t).setLatLng(p);  // can't chain setLatLng because of bug
              if (trackcontrol.isTracking()) { map.panTo(p); }
          } else {
              airplane = flightMarker(p).addTo(map).rotate(h).setShadow(a).stamp(t);
              // airplane.on('click', function() {
              //     infocontrol.content(flightinfo);
              // });
          }
      }   // end phat

      // update position of airplane, using animation
      function aniPhats(p, h, a, t, s) {  // position, heading, altitude, time, speed
          // if (!isNaN(a)) { airplane.setShadow(a); }
          if (typeof curpos !== 'object') {
              phat(p, h, a, t);
              return;
          }
          if (curpos && !curpos.equals(p)) {  // calculate heading from positions
              h = calcHeading(curpos, p);
          }
          curheading = h;

          var dt = t - airplane.stamp();  // time delta between updates in milliseconds
          airplane.stamp(t);
          // if (dt > 120000 || map.getZoom() < 5) {  // don't animate jumps or low zoom levels
          if (dt > 240000) {  // don't animate jumps greater than 4 minutes
              phat(p, h, a, t);
              // if (tracking) { map.panTo(p); }
              return;
          }

          if (debug && curspeed && Math.abs(s - curspeed) > 100) { console.log('speed jump', s, curspeed); }
          if (s) { curspeed = s; }    // valid speed

          var fminute = 60000 / aniRate;  // a minute of frames

          currot = (currot + 360) % 360;
          var turn = smallAngle(currot, h);

          // number of frames to move that distance at current speed (s)
          if (debug) { console.log('curspeed: '+curspeed, 'speedMph: '+pos.speedMph, 'turn: '+turn.toFixed(2)); }
          frames = !isNaN(curspeed) ? Math.floor(curpos.distanceTo(p) * 2236.936292 / (curspeed * aniRate)) : 0;
          if (frames <= 0) {
              curpos = p;
              return;
          }
          if (debug) {  console.log('frames: '+frames+' at: '+curspeed+' mph'); }

          frames = Math.min(frames, fminute * 2);
          if (frames > fminute) {
              frames -= Math.ceil((frames - fminute) * 0.5);
          }
          rotframes = Math.ceil(frames/2);
          vlat = (p.lat - curpos.lat) / frames;
          vlng = (p.lng - curpos.lng) / frames;
          vrot =  turn / rotframes;
          if ((vrot > rotRate && curspeed > 200) || vrot > rotRate * 2) { // max 2 degrees per second
              if (debug) { console.log('rotate limit: '+vrot); }
              vrot = rotRate;
              rotframes = turn / vrot;
          }

          // only continue on after loss of data if plane is at altitude and speed
          if (curspeed > 250 && a > 10000) {
              frames += fminute; // plus one more minute of frames
          }

          // animation timer
          if (!anitimer) {
              anitimer = setInterval(step, aniRate);  // airplane animation
          }

          function step() {   // animation step
              if (curstatus === 'L') {    // land plane
                  curpos = apos;
                  frames = 0;
              } else {
                  curpos = createLatLng(curpos.lat + vlat, curpos.lng + vlng, wrap);
              }
              currot += vrot;
              if (!zooming && !panning) { // don't update position while zooming or panning animation is in progress
                  airplane.rotate(currot).setLatLng(curpos);  // can't chain setLatLng because of bug
                  if (trackcontrol.isTracking()) {    // time to scroll?
                      if (trackingDist === 0) { map.panTo(curpos); }  // continuous tracking
                      else {  // jump tracking
                          var mapcenter = map.getSize().multiplyBy(0.5);
                          var curpixel = map.latLngToContainerPoint(curpos);
                          // if (debug) { console.log(mapcenter.toString(), curpixel.toString()); }
                          if (curpixel.x < mapcenter.x * (1-trackingDist) || curpixel.x > mapcenter.x * (1+trackingDist) ||
                                  curpixel.y < mapcenter.y * (1-trackingDist) || curpixel.y > mapcenter.y * (1+trackingDist)) {
                              map.panBy([1.9 * (curpixel.x - mapcenter.x), 1.9 * (curpixel.y - mapcenter.y)]);
                          }
                      }
                  }
                  if (layers.path) {  // draw tail
                      multi[0][0] = curpos;
                      layers.pathHalo.setLatLngs(multi);
                      layers.path.setLatLngs(multi);
                  }
              }
              if (frames <= 0) {  // stop movement
                  vlat = 0;
                  vlng = 0;
                  vrot = 0;
                  clearInterval(anitimer);
                  anitimer = null;
              } else {
                  if (rotframes <= 0) {
                      vrot = 0;
                  } else {
                      rotframes--;
                  }
                  frames--;
              }
          }   // end step

      }   // end aniPhats

  } // end getFlight

  function setfullview(m) { // set map view including both airports and current position of flight
      // var flightBounds;   // area of world to display

      // Workaround for EWR to SIN flight
      // if (Math.abs(180 - Math.abs(dpos.lng - apos.lng)) < 2) {
      //  m.fitWorld();
      //  return;
      // }

      // Workaround for Leaflet issue #1481
      // var tempa = createLatLng(apos.lat, apos.lng, false);
      // var tempd = createLatLng(dpos.lat, dpos.lng, false);
      // var tempf = createLatLng(fpos.lat, fpos.lng, false);

      if (!flightBounds) {
        flightBounds = L.latLngBounds([ dpos, apos, fpos ]).pad(0.05);
      }
      m.fitBounds(flightBounds);

      // Workaround for Leaflet issue #1481
      // apos = tempa; amarker.setLatLng(apos);
      // dpos = tempd; dmarker.setLatLng(dpos);
      // fpos = tempf; airplane.setLatLng(fpos);
  }

  function centerTracker() {
    map.invalidateSize();
    setfullview(map);
  }

  map.centerTracker = centerTracker;

  function setFlightPath(all) { // draw flight positions
      var p = actualposs;
      if (p.length < 2) { return; }
      var positions = [];
      var last = null, ct, tail;
      var i = 1;
      if (all || !curpos || curspeed < 120 || flightData.statusCode === 'L' || flightData.statusCode === 'D') {   // draw all positions
          tail = createLatLng(+p[i].lat, +p[i].lon, wrap);
      } else { // find last point in flight path to be displayed
          var m = Math.min(p.length, 10);
          for ( ; i < m; i++) {
              tail = createLatLng(+p[i].lat, +p[i].lon, wrap);
              var h = calcHeading(curpos, tail);
              // console.log('angle for '+i+' = '+smallAngle(curheading, h), curheading, h);
              if (Math.abs(smallAngle(curheading, h)) > 90) { break; }
              // var angle = h - curheading;
              // angle = angle > 180 ? angle - 360 : (angle < -180 ? angle + 360 : angle );
              // if (angle > 90) { break; }
          }
      }
      multi = [[tail, tail]]; // dummy path for tail
      for (; i < p.length; i++) {
          ct = Date.parse(p[i].date);
          if (last) {
              if (Math.abs(ct - last) > 120000) { // no data for 2 minutes
                  multi.push(positions);
                  positions = [];
              }
          }
          positions.push(createLatLng(+p[i].lat, +p[i].lon, wrap));
          last = ct;
      }
      multi.push(positions);
      if (layers.path) {  // layer already exists
          layers.pathHalo.setLatLngs(multi);
          layers.path.setLatLngs(multi);
      } else {    // create layer
          layers.pathHalo = L.multiPolyline(multi, { color: '#828483', weight: 6, opacity: 0.5, clickable: false });
          layers.path = L.multiPolyline(multi, { color: '#55f241', weight: 4, opacity: 0.8, clickable: false });
      }
      if (showPath) {
          layers.pathHalo.addTo(map).bringToFront();
          layers.path.addTo(map).bringToFront();
      }
  } // end setFlightPath

  function calcHeading(p1, p2) {  // heading in degrees of vector from p1 to p2
      var toRad = L.LatLng.DEG_TO_RAD;
      var lat1 = p1.lat * toRad,
              lat2 = p2.lat * toRad,
              dLng = (p2.lng - p1.lng) * toRad;
      return (Math.atan2(
              Math.sin(dLng)*Math.cos(lat2),
              Math.cos(lat1)*Math.sin(lat2) - Math.sin(lat1)*Math.cos(lat2)*Math.cos(dLng)) *
          L.LatLng.RAD_TO_DEG + 360) % 360;
  }

  function smallAngle(o, n) { // smallest angle from o to n (degrees)
      var t = n - o;  // difference between new and old
      return t > 180 ? t - 360 : (t < -180 ? t + 360 : t );
  }

  function scaleTowersBAK(m) {   // scale tower icon based on zoom of map m
      // control tower icon options
      var towerproto = {
              iconUrl: images['tower_large'],
              iconRetinaUrl: images['tower_large_2x'],
              iconSize: [78, 151],    // full size
              iconAnchor: [16, 94]
          };

      var towerscale = [ 0.25, 0.375, 0.5, 0.625, 0.75, 0.875, 1 ];

      var opts = $.extend({}, towerproto);    // copy
      var scale = towerscale[Math.min(m.getZoom(), towerscale.length-1)];
      opts.iconSize = [opts.iconSize[0] * scale, opts.iconSize[1] * scale];
      opts.iconAnchor = [opts.iconAnchor[0] * scale, opts.iconAnchor[1] * scale];
      return L.icon(opts);
  }

  function scaleTowers(m, depArr, diverted) {
    var bkgColorStyle = (diverted) ? 'flight-tracker-icon-warning-color' : 'flight-tracker-icon-standard-color';

    return L.divIcon({
      iconAnchor: [21, 57],
      iconSize: [44, 54],
      className: 'flight-tracker-map-airport-icon',
      html: '<div class="flight-tracker-map-airport-icon-top ' + bkgColorStyle + '">' +
            '<div class="inner">' +
            '<img src="' + (depArr === 'departure' ? airportDepartureIcon : airportArrivalIcon) + '" />' +
            '</div>' +
            '</div>' +
            '<div class="flight-tracker-map-airport-icon-bottom"></div>'
    });
  }
}

function createLatLng(lat, lon, wrap) {
    return L.latLng(lat, wrap && lon>0 ? lon-360 : lon, true);
}



// WEBPACK FOOTER //
// ./shared/lib/flick/src/got-flight.js